var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7879_154113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 14.2691 2.67578 17.9141 6.4418 19.3484C6.35 18.5676 6.25273 17.2801 6.4625 16.377C6.64336 15.6 7.63008 11.4285 7.63008 11.4285C7.63008 11.4285 7.33242 10.8328 7.33242 9.95C7.33242 8.5668 8.13438 7.5332 9.13359 7.5332C9.98359 7.5332 10.3934 8.17109 10.3934 8.93516C10.3934 9.78945 9.84922 11.066 9.56836 12.2504C9.33437 13.241 10.066 14.0492 11.0426 14.0492C12.8117 14.0492 14.1727 12.1832 14.1727 9.49023C14.1727 7.10586 12.4594 5.44023 10.0133 5.44023C7.18203 5.44023 5.51953 7.56445 5.51953 9.76016C5.51953 10.616 5.84844 11.5328 6.26016 12.032C6.31217 12.087 6.34111 12.1599 6.34102 12.2355C6.34102 12.2629 6.33711 12.2906 6.32969 12.3172C6.25391 12.6324 6.08516 13.3082 6.05313 13.4461C6.00898 13.6277 5.90898 13.6672 5.71953 13.5789C4.47656 13.0004 3.69961 11.1828 3.69961 9.72305C3.69961 6.58203 5.98086 3.69883 10.2762 3.69883C13.7297 3.69883 16.4141 6.15977 16.4141 9.44805C16.4141 12.8789 14.2512 15.6406 11.248 15.6406C10.2387 15.6406 9.29141 15.1152 8.96641 14.4961C8.96641 14.4961 8.46719 16.3977 8.34609 16.8629C8.11133 17.7664 7.45937 18.9094 7.05547 19.5586C7.98672 19.8461 8.975 20 10 20C15.5227 20 20 15.5223 20 10C20 4.47773 15.5227 0 10 0C4.47734 0 0 4.47734 0 10Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7879_154113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIcon);
export default __webpack_public_path__ + "static/media/pinterest-icon.48479988db55e8fb6a999f83bfac29ed.svg";
export { ForwardRef as ReactComponent };